import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQs</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What are advanced facial aesthetics treatments?", answer: "Advanced facial aesthetics include non-surgical procedures like Botox, dermal fillers, chemical peels, skin tightening, anti-ageing treatments, jawline contouring, acne scar removal, and laser-based therapies. These treatments improve skin texture, reduce wrinkles, enhance facial features, and provide a natural, youthful appearance without surgery." },
                  { question: "Are facial aesthetic treatments safe?", answer: "Yes, when performed by trained and experienced specialists, these treatments are safe. They use medically approved products and advanced equipment. Mild swelling or redness may occur but usually settles quickly. A proper consultation ensures the treatment matches your skin type and goals." },
                  { question: "How long do the results last?", answer: "Results depend on the treatment. Botox may last 4–6 months, fillers 9–18 months, and laser or skin rejuvenation treatments may show long-term improvement with proper skincare. Regular sessions and good skincare habits help maintain results for a longer duration." },
                  {question: "Who is an ideal candidate for facial aesthetics?", answer: "Anyone looking to reduce signs of ageing, improve facial contours, enhance skin texture, or treat scars and pigmentation can consider these treatments. Both men and women benefit from these procedures. A consultation helps determine which treatment best suits your skin goals."},
                  {question: "Do these treatments require downtime?", answer: "Most non-surgical facial aesthetic treatments have minimal or zero downtime. Patients can return to normal activities the same day. Some treatments may cause mild redness or swelling, which settles within hours or a couple of days. Your doctor will guide post-care for best results."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
